const SHARED_AUTH_KEYS = ["access_token", "refresh_token"] as const;

export type SharedAuthKey = (typeof SHARED_AUTH_KEYS)[number];

export function readSharedAuthItem(key: SharedAuthKey): string | null {
  const shared = localStorage.getItem(key);
  if (shared !== null) {
    sessionStorage.removeItem(key);
    return shared;
  }

  const legacy = sessionStorage.getItem(key);
  if (legacy !== null) {
    localStorage.setItem(key, legacy);
    return legacy;
  }

  return null;
}

export function writeSharedAuthItem(key: SharedAuthKey, value: string): void {
  localStorage.setItem(key, value);
  sessionStorage.removeItem(key);
}

export function removeSharedAuthItem(key: SharedAuthKey): void {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}
